import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsCategories(
  {
    page, size, direction, sort,
  }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-categories`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsCategory(goodsCategoryId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-categories/${goodsCategoryId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsCategory(
  {
    name,
    nameEn,
    coverPath,
    code,
    seriesId,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-categories`,
    method: 'post',
    data: {
      name,
      nameEn,
      code,
      coverPath,
      seriesId,
    },
  });
}

/**
 * 更新
 * @param goodsCategoryId
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsCategory(goodsCategoryId, {
  name,
  nameEn,
  coverPath,
  code,
  seriesId,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-categories/${goodsCategoryId}`,
    method: 'patch',
    data: {
      name,
      nameEn,
      coverPath,
      code,
      seriesId,
    },
  });
}

/**
 * 删除
 * @param goodsCategoryId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsCategory(goodsCategoryId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-categories/${goodsCategoryId}`,
    method: 'delete',
  });
}

export function _updateGoodsSort({ idStr, sortStr, oldIndex, newIndex
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website/category/update`,
    method: 'post',
    params: {
      idStr: idStr,
      sortStr: sortStr,
      oldIndex: oldIndex,
      newIndex: newIndex
    }
  });
}
/**
 * 查询系列下的商品
 */
export function _queryGoodsSeriesGoods(
  {
    id, page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-category-goods`,
    method: 'get',
    params: {
      id,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 推荐系列下的商品
 */
export function _recommendSeriesGoods(goodsCategoryId, goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-categories/${goodsCategoryId}/${goodsId}/recommend`,
    method: 'patch',
  });
}

/**
 * 取消推荐
 */
export function _cancelRecommendGoods(goodsCategoryId, goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-categories/${goodsCategoryId}/${goodsId}/cancel`,
    method: 'patch',
  });
}

export default {};
